/**
 * detect if browser is opened in desktop or mobile
 * assumption is that if window.orientation is undefined, user is on desktop
 */
export function isMobileDevice() {
  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

/**
 * Check if screen width is larger than 600px
 * @returns {boolean} true if screen width > 600px, false otherwise
 */
export const isLargeScreen = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth > 600;
}
